import { IValidationRule } from "@/types"

const assetEndHoldershipValidationRules: { [s: string]: IValidationRule } = {
    date: {
        required: true
    },
}

export default assetEndHoldershipValidationRules
